<template>
    <div class="login_container">
        <div class="login_shell">
            <section class="brand_panel">
                <div>
                    <div class="brand_logo">
                        <img src="../assets/logo.jpg" alt="送呗Logo">
                    </div>
                    <p class="brand_label">Songbay Console</p>
                    <h1>送呗Songbay</h1>
                    <p class="brand_desc">新一代即时配送与校园跑腿综合运营平台</p>
                </div>
                <ul class="brand_highlights">
                    <li>· 实时调度与履约监控</li>
                    <li>· 多角色精细化权限体系</li>
                    <li>· 数据可视化经营洞察</li>
                </ul>
            </section>
            <section class="form_panel">
                <div class="form_header">
                    <span class="badge">欢迎登录</span>
                    <h2>送呗Songbay后台管理系统</h2>
                    <p>统一账号体系，保障业务闭环与数据安全</p>
                </div>
                <el-form :model="loginForm" ref="LoginFormRef" :rules="loginFormRules" label-width="0px" class="login_form">
                    <el-form-item prop="username">
                        <el-input v-model="loginForm.userPhone" placeholder="请输入登录手机号" prefix-icon="iconfont icon-user"></el-input>
                    </el-form-item>
                    <el-form-item prop="password">
                        <el-input type="password" v-model="loginForm.password" placeholder="请输入密码" show-password prefix-icon="iconfont icon-3702mima"></el-input>
                    </el-form-item>
                    <el-form-item class="form_actions">
                        <el-button class="btn-login" type="primary" @click="submit">立即登录</el-button>
                        <el-button class="btn-reset" @click="reset">重置</el-button>
                    </el-form-item>
                </el-form>
            </section>
        </div>
        <Vcode :show="isShow" @success="success" @close="close" />
    </div>
</template>

<script>
    import Vcode from "vue-puzzle-vcode";
    export default {
        data() {
            return {
                //数据绑定
                loginForm: {
                    userPhone: "",
                    password: ""
                },
                //表单验证规则
                loginFormRules: {
                    userPhone: [
                        { required: true, message: '请输入登录名', trigger: 'blur' },
                        {
                            min: 11,
                            max: 11,
                            message: '登录名长度11 个字符',
                            trigger: 'blur'
                        }
                    ],
                    password: [
                        { required: true, message: '请输入密码', trigger: 'blur' },
                        {
                            min: 6,
                            max: 15,
                            message: '密码长度在 6 到 15 个字符',
                            trigger: 'blur'
                        }
                    ]
                },
                isShow: false, // 验证码模态框是否出现
            };
        },
        components: {
            Vcode
        },
        methods: {
            reset(){
                this.loginForm.password='';
                this.loginForm.userPhone='';
            },
            submit() {
                this.isShow = true;
            },
            // 用户通过了验证
            success() {
                this.$refs.LoginFormRef.validate(async valid => {
                    if (!valid) {
                        return
                    }
                    console.log(this.loginForm)
                    //发送请求进行登录
                    const { data: res } = await this.$http.post('user/login',this.loginForm);
                    console.log(res)
                    if (res.code !== 200) {
                        return this.$message.error('登录失败:' + res.msg); //console.log("登录失败:"+res.meta.msg)
                    }
                    this.$message.success('登录成功');
                    //保存token
                    window.sessionStorage.setItem('token', res.data.token);
                    //存储店铺id
                    window.sessionStorage.setItem("shopId",res.data.shopId);
                    window.sessionStorage.setItem('schoolId', res.data.schoolId != null && res.data.schoolId !== 0 ? String(res.data.schoolId) : '');
                    window.sessionStorage.setItem('schoolName', res.data.schoolName || '');
                    window.sessionStorage.setItem('roleKey', res.data.roleKey || '');
                    window.sessionStorage.setItem('schoolScoped', res.data.schoolScoped === true ? 'true' : 'false');
                    //保存user
                    // window.sessionStorage.setItem('uId',res.data.data.userId)
                    // console.log(window.sessionStorage.getItem('token'))
                    // 导航至/homepage
                    await this.$router.push('/homepage')
                    // await this.$router.push({name: 'index', params: {user: res.data.data}})
                })
                this.isShow = false; // 通过验证后，需要手动隐藏模态框
            },
            // 用户点击遮罩层，应该关闭模态框
            close() {
                this.isShow = false;
            }
        }
    };
</script>
<style scoped>
.login_container {
    min-height: 100vh;
    padding: 40px 24px;
    background: linear-gradient(135deg, #0d3b3f 0%, #00695c 40%, #00C2A8 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    overflow: hidden;
}

.login_container::before {
    content: '';
    position: absolute;
    width: 600px;
    height: 600px;
    background: radial-gradient(circle, rgba(0, 194, 168, 0.3), transparent 70%);
    top: -300px;
    right: -200px;
    border-radius: 50%;
}

.login_container::after {
    content: '';
    position: absolute;
    width: 400px;
    height: 400px;
    background: radial-gradient(circle, rgba(0, 194, 168, 0.2), transparent 70%);
    bottom: -200px;
    left: -100px;
    border-radius: 50%;
}

.login_shell {
    width: 1100px;
    min-height: 560px;
    border-radius: 24px;
    overflow: hidden;
    display: flex;
    background: rgba(255, 255, 255, 0.98);
    border: 1px solid rgba(255, 255, 255, 0.3);
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
    backdrop-filter: blur(10px);
    position: relative;
    z-index: 1;
}

.brand_panel {
    flex: 1;
    padding: 72px 56px;
    color: #ffffff;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background: linear-gradient(135deg, #00C2A8 0%, #00AB95 50%, #008c7a 100%);
    position: relative;
    overflow: hidden;
}

.brand_panel::before {
    content: '';
    position: absolute;
    width: 300px;
    height: 300px;
    background: radial-gradient(circle, rgba(255, 255, 255, 0.1), transparent 70%);
    top: -100px;
    right: -100px;
    border-radius: 50%;
}

.brand_panel::after {
    content: '';
    position: absolute;
    width: 200px;
    height: 200px;
    background: radial-gradient(circle, rgba(255, 255, 255, 0.08), transparent 70%);
    bottom: -50px;
    left: -50px;
    border-radius: 50%;
}

.brand_logo {
    width: 80px;
    height: 80px;
    border-radius: 20px;
    background: rgba(255, 255, 255, 0.95);
    border: 2px solid rgba(255, 255, 255, 0.4);
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
}

.brand_logo img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.brand_label {
    margin-top: 24px;
    text-transform: uppercase;
    font-size: 14px;
    letter-spacing: 4px;
    color: rgba(230, 255, 251, 0.75);
}

.brand_panel h1 {
    margin: 16px 0 8px;
    font-size: 44px;
    font-weight: 700;
    text-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.brand_desc {
    max-width: 320px;
    line-height: 1.6;
    color: rgba(230, 255, 251, 0.82);
}

.brand_highlights {
    list-style: none;
    padding: 0;
    margin: 48px 0 0;
    font-size: 16px;
    line-height: 1.8;
    color: rgba(230, 255, 251, 0.9);
}

.form_panel {
    flex: 1;
    background: #ffffff;
    padding: 64px 72px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: relative;
}

.form_header .badge {
    display: inline-flex;
    align-items: center;
    padding: 6px 16px;
    height: auto;
    border-radius: 20px;
    background: linear-gradient(135deg, rgba(0, 194, 168, 0.15), rgba(0, 194, 168, 0.08));
    color: #00C2A8;
    font-size: 13px;
    font-weight: 600;
    border: 1px solid rgba(0, 194, 168, 0.2);
}

.form_header h2 {
    margin: 18px 0 8px;
    font-size: 28px;
    font-weight: 700;
    color: #1f2937;
}

.form_header p {
    color: #7a8c9f;
    margin-bottom: 32px;
}

.login_form {
    width: 100%;
}

.form_actions {
    display: flex;
    gap: 16px;
    margin-top: 12px;
}

.btn-login {
    flex: 1;
    height: 50px;
    border-radius: 12px;
    border: none;
    background: linear-gradient(135deg, #00C2A8 0%, #00AB95 100%);
    font-size: 16px;
    font-weight: 600;
    letter-spacing: 1px;
    box-shadow: 0 4px 12px rgba(0, 194, 168, 0.3);
    transition: all 0.3s ease;
}

.btn-login:hover,
.btn-login:focus {
    background: linear-gradient(135deg, #00AB95 0%, #009582 100%);
    box-shadow: 0 6px 20px rgba(0, 194, 168, 0.4);
    transform: translateY(-2px);
}

.btn-reset {
    width: 140px;
    height: 50px;
    border-radius: 12px;
    border: 2px solid #e5e7eb;
    color: #6b7280;
    font-weight: 500;
    transition: all 0.3s ease;
}

.btn-reset:hover,
.btn-reset:focus {
    border-color: #00C2A8;
    color: #00C2A8;
    background: rgba(0, 194, 168, 0.05);
}

.form_panel ::v-deep .el-input__inner {
    height: 50px;
    border-radius: 12px;
    border: 2px solid #e9eef3;
    transition: all 0.3s ease;
    padding-left: 42px;
    font-size: 14px;
}

.form_panel ::v-deep .el-input__inner:focus {
    border-color: #00C2A8;
    box-shadow: 0 0 0 4px rgba(0, 194, 168, 0.1);
    background: #fafffe;
}

.form_panel ::v-deep .el-input__inner:hover {
    border-color: #00C2A8;
}

.form_panel ::v-deep .el-input__prefix {
    left: 12px;
    color: #7a8c9f;
}

@media (max-width: 1024px) {
    .login_shell {
        flex-direction: column;
        width: 95%;
        max-width: 500px;
    }

    .brand_panel,
    .form_panel {
        padding: 40px 32px;
    }
    
    .brand_panel h1 {
        font-size: 32px;
    }
    
    .form_header h2 {
        font-size: 24px;
    }
}
</style>
